import { RouteProps } from "react-router";
import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";

import * as selectors from "src/bepaid/store/model/Fetch/selectors";
import * as actions from "src/bepaid/store/model/Fetch/actions";
// import * as FormAction from "src/ipm-shared/components/Form/actions";

import Component from "./View";

const mapStateToProps = (state: RootState) => ({
  getSelectedCustomersId: selectors.getSelectedCustomersId(state),
  isFetchingCustomer: selectors.getIsFetching(state),
  listCustomer: selectors.getCustomerList(state),
  total: selectors.getTotalCustomers(state)
});

const mapDispatchToProps = {
  selectCustomers: actions.selectCustomers,
  getCustomerList: actions.getCustomerList
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps;

export default connect(mapStateToProps, mapDispatchToProps)(Component);
